import { useForm } from "react-hook-form";
import { tx } from "shared/types/i18n";

import { SecondaryButton } from "../../components/form/button";
import { Form } from "../../components/form/form";
import { FormTextInput } from "../../components/form/form-text-input";
import { LoadingButton } from "../../components/form/loading-button";
import { Link } from "../../components/link";
import { Text } from "../../components/text";
import { useMamaNavigateState } from "../../navigation/use-mama-navigate-state";
import { useUserHasInteractedWithSignupForm } from "../../util/data-layer-actions";
import { isEmailRegex } from "../../util/regex";
import { AuthPagesEnum } from "../constants";
import { useHandleMagicLinkSignUp } from "../hooks/use-handle-magic-link-sign-up";

export const CognitoMagicLinkSignUp: React.FC = () => {
  const handleMagicLinkSignUp = useHandleMagicLinkSignUp();

  const { prefillValues } = useMamaNavigateState();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty },
  } = useForm<{
    name: string;
    email: string;
  }>({ defaultValues: prefillValues });

  useUserHasInteractedWithSignupForm(isDirty);

  return (
    <Form onSubmit={handleSubmit(handleMagicLinkSignUp)}>
      <FormTextInput
        title={{ tx: "auth.signUp.inputs.name.title" }}
        placeholder={{ tx: "auth.signUp.inputs.name.placeholder" }}
        {...register("name", {
          required: tx("auth.signUp.inputs.name.fieldMissingError"),
          validate: (value) => {
            if (value.trim() === "") {
              return tx("auth.signUp.inputs.name.fieldMissingError");
            }
          },
        })}
        error={{ txUnchecked: errors.name?.message }}
      />
      <FormTextInput
        title={{ tx: "auth.signUp.inputs.email.title" }}
        placeholder={{ tx: "auth.signUp.inputs.email.placeholder" }}
        autoComplete="username"
        {...register("email", {
          required: tx("auth.signUp.inputs.email.fieldMissingError"),
          pattern: {
            value: isEmailRegex,
            message: tx("auth.signUp.inputs.email.notAnEmailError"),
          },
        })}
        error={{ txUnchecked: errors.email?.message }}
      />
      <LoadingButton
        type="submit"
        loading={isSubmitting}
        Button={SecondaryButton}
        tx="auth.signUp.signUpButton"
      />
      <Text
        as="p"
        tx="auth.navigation.signInInstead"
        txComponents={{
          SignInLink: <Link href={AuthPagesEnum.MAGIC_SIGN_IN} />,
        }}
      />
    </Form>
  );
};
